GraphQL ID: presetAffixes
list:
  - name: Power DPS
    value:
      {
        "affixes": ["Berserker", "Assassin", "Dragon"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision

  - name: Power DPS (no dragon)
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Assassin"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision

  - name: Condi DPS
    value:
      {
        "affixes": ["Viper", "Sinister"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise

  - name: Condi DPS Rampager
    value:
      {
        "affixes": ["Viper", "Sinister", "Rampager"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Precision

  - name: Hybrid DPS
    value:
      {
        "affixes": ["Viper", "Sinister", "Grieving"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise

  - name: Power Boon
    value:
      {
        "affixes": ["Berserker", "Assassin", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "84.5",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision # + Concentration

  - name: Condi Boon
    value:
      {
        "affixes": ["Viper", "Sinister", "Ritualist"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Condi Boon/Support
    value:
      {
        "affixes": ["Viper", "Seraph", "Celestial"],
        "optimizeFor": "Damage",
        "minBoonDuration": "79",
        "minQuicknessDuration": "0"
      }
    infusions: None

  - name: Heal (Raid)
    value:
      {
        "affixes": ["Harrier", "Minstrel", "Magi"],
        "optimizeFor": "Healing",
        "minBoonDuration": "100",
        "minQuicknessDuration": "0"
      }
    infusions: Healing Power + Concentration

  - name: Heal (Fractal)
    value:
      {
        "affixes": ["Harrier", "Minstrel", "Cleric"],
        "optimizeFor": "Healing",
        "minBoonDuration": "100",
        "minQuicknessDuration": "0"
      }
    infusions: Healing Power + Concentration

  # -------------------------------------------------------------------------------------------- #

  - name: Berserker Only
    hidden: true
    value:
      {
        "affixes": ["Berserker"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision

  - name: Trailblazer/Dire
    hidden: true
    value:
      {
        "affixes": ["Trailblazer", "Dire"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise

  - name: Condi Barrier Specter
    hidden: true
    value:
      {
        "affixes": ["Ritualist", "Carrion"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise

  - name: Power Alacrity Willbender 14%
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Assassin", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "14",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision # + Concentration

  - name: Power Alacrity Luminary 24%
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Dragon", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "24",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision # + Concentration

  - name: Power Quickbrand 25%
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Assassin", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "25"
      }
    infusions: Power + Precision # + Concentration

  - name: Condi Quickness Herald 0%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Sinister", "Ritualist"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Power Boon Daredevil 99.7%
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Assassin", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "99.7"
      }
    infusions: Power + Precision # + Concentration

  - name: Condi Hybrid Firebrand 40%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Seraph", "Celestial"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "40"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Condi Hybrid Firebrand 78%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Seraph", "Celestial"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "78"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Condi Alacrity Scourge 28.8%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Ritualist"],
        "optimizeFor": "Damage",
        "minBoonDuration": "28.8",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Condi Quickness Harbinger 12.8%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Ritualist"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "12.8"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Condi Boon 0%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Ritualist"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Condi Quickness Berserker 44.7%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Sinister", "Ritualist"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "44.7"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Quickness Condi Untamed 42%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Ritualist"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "42"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Alacrity Power Renegade 37.4%
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Diviner", "Dragon"],
        "optimizeFor": "Damage",
        "minBoonDuration": "37.4",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision # + Concentration

  - name: Alacrity Condi Renegade 42%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Ritualist"],
        "optimizeFor": "Damage",
        "minBoonDuration": "42",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Condi Quickbrand 40%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Ritualist", "Sinister"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "40"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Alacrity Condi Specter 32.8%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Ritualist"],
        "optimizeFor": "Damage",
        "minBoonDuration": "32.8",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Condi Alacrity Willbender 14%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Grieving", "Celestial"],
        "optimizeFor": "Damage",
        "minBoonDuration": "14",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Alacrity Power Tempest 34%
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Assassin", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "34.4",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision # + Concentration

  - name: Alacrity Power Tempest 31%
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Assassin", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "31.7",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision # + Concentration

  - name: Alacrity Fire Tempest Inferno 22%
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "22",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision # + Concentration

  - name: Alacrity Condi Tempest 31%
    hidden: true
    value:
      {
        "affixes": ["Viper", "Ritualist", "Sinister"],
        "optimizeFor": "Damage",
        "minBoonDuration": "31",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise # + Concentration

  - name: Condi Tempest
    hidden: true
    value:
      {
        "affixes": ["Viper", "Grieving", "Sinister"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "0"
      }
    infusions: Condition Damage + Expertise

  - name: Heal Specter 88%
    hidden: true
    value:
      {
        "affixes": ["Plaguedoctor", "Minstrel", "Giver"],
        "optimizeFor": "Healing",
        "minBoonDuration": "88",
        "minQuicknessDuration": "0"
      }
    infusions: Healing Power + Concentration

  - name: Power Quickness Untamed 40%
    hidden: true
    value:
      {
        "affixes": ["Berserker", "Assassin", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "0",
        "minQuicknessDuration": "40"
      }
    infusions: Power + Precision # + Concentration

  - name: Alacrity Power Antiquary 13%
    value:
      {
        "affixes": ["Berserker", "Assassin", "Diviner"],
        "optimizeFor": "Damage",
        "minBoonDuration": "13",
        "minQuicknessDuration": "0"
      }
    infusions: Power + Precision # + Concentration
